import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';

/**
 * An animated column for showing data in a scoreboard
 */
@Component({
    selector: 'scoreboard-column',
    templateUrl: './scoreboard-column.component.html',
    styleUrls: ['./scoreboard-column.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ScoreboardColumnComponent implements OnChanges {

    /** The current score */
    @Input() currentScore: number;
    /** The  max score (which sets the upper bound of the column) */
    @Input() maxScore: number;
    /** Flag to determine whether the column should be highlighted */
    @Input() highlighted: boolean = false;
    /** Flag to determine whether to display loading animation */
    @Input() loading: boolean = false;
    /** Event emitted once animation has completed */
    @Output() animationCompleted = new EventEmitter<void>();
    /** The current score expressed as a percentage of the max score */
    public currentPercentageOfMax: number;
    /** Animation time (in seconds) */
    public animationTime: number = 2;

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.currentScore || changes.maxScore) {
            // Calculate the current score as a percentage of the max score 
            this.currentPercentageOfMax = this.currentScore / this.maxScore * 100;
        }

        if(changes.loading?.currentValue == false) {
            console.log('LOADING CHANGES:', changes.loading);
            setTimeout(() => this.animationCompleted.next(), this.animationTime * 1000);
        }
    }
}
